import axios from "axios";
import { store } from "../index";
import EcommerceServices from "./EcommerceServices";
const instance = axios.create({
  baseURL: window.config.apiBase.baseUrl,
  headers: {
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "Content-Security-Policy":
      "default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self' data:; font-src 'self'; connect-src 'self'; frame-ancestors 'none';",
    "X-Frame-Options": "DENY",
    "X-Content-Type-Options": "nosniff",
    "Referrer-Policy": "no-referrer",
    "Permissions-Policy":
      "geolocation=(), microphone=(), camera=(), vibrate=()",
  },
});

const setToken = () => {
  const as = store.getState();
  // @ts-ignore
  const jwt = as.sso ? as.sso.token : null;
  instance.defaults.headers.common["Authorization"] = "Bearer " + jwt;
  instance.interceptors.response.use(
    (response) => {
      if (response.status === 403) {
        window.location.href = window.location.origin + "/LogOut";
      }
      return response;
    },
    (error) => {
      console.log(error);
      if (error.response?.status === 403) {
        window.location.href = window.location.origin + "/LogOut";
      }
      return Promise.reject(error);
    }
  );
};

const api = {
  EcommerceServices: EcommerceServices(instance),
  setToken: setToken,
};
export default api;
